import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraCoachingSecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M52.9271 44.6035C56.0044 37.5361 55.7979 27.1583 51.3459 20.7366C48.256 16.2793 42.1912 12.8355 36.8847 12.2589C31.3434 11.6565 25.4426 12.1143 20.5775 14.9959C16.3021 17.5273 12.6872 21.3036 10.7118 25.96C9.43644 28.9685 8.86575 32.2805 9.02655 35.5524C9.34815 42.093 12.323 48.7974 17.7855 52.3552C24.3832 56.6535 33.3061 58.4557 40.7944 55.656C45.4151 53.9293 50.7263 49.6551 52.9255 44.6035H52.9271Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M48.6851 33.2267C49.2778 41.0217 44.4364 49.0898 35.1935 50.4615C19.8274 52.7392 9.05366 36.6399 20.0844 24.0647C29.5339 13.2901 47.5658 18.5281 48.6851 33.2267Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M32.3212 45.5512C38.0206 45.5512 42.6409 40.8438 42.6409 35.0369C42.6409 29.2299 38.0206 24.5225 32.3212 24.5225C26.6218 24.5225 22.0015 29.2299 22.0015 35.0369C22.0015 40.8438 26.6218 45.5512 32.3212 45.5512Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M32.3213 39.3078C34.6364 39.3078 36.5132 37.3956 36.5132 35.0368C36.5132 32.678 34.6364 30.7659 32.3213 30.7659C30.0062 30.7659 28.1294 32.678 28.1294 35.0368C28.1294 37.3956 30.0062 39.3078 32.3213 39.3078Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M32.9133 34.2367L20.8602 15.5486C20.5753 15.1067 19.9927 14.9839 19.559 15.2743L19.5577 15.2751C19.124 15.5655 19.0035 16.1591 19.2885 16.6009L31.3416 35.2891C31.6265 35.7309 32.2091 35.8537 32.6428 35.5634L32.6441 35.5625C33.0778 35.2721 33.1983 34.6786 32.9133 34.2367Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M20.5065 7L26.3064 16.08L24.2112 22.2833L24.2096 22.2865H24.2065L17.7917 21.7243L11.9934 12.6443L18.7298 13.706L20.5065 7Z'
        fill={spotIllustration.primary.fill}
      />
    </Svg>
  )
}
